<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row class="d-flex align-center justify-end px-4">
          <v-btn color="success" @click="parkingFineReportingTaskDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $vuetify.lang.t('$vuetify.ADD_NEW') }}
          </v-btn>
        </v-row>
        <v-data-table
          :headers="[
            {
              text: 'ID',
              align: 'start',
              sortable: false,
              value: 'ID'
            },
            {
              text: $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.GROUP_NAME'),
              align: 'start',
              sortable: false,
              value: 'vehicleGroupName'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EMAIL_TO'
              ),
              align: 'start',
              sortable: false,
              value: 'emailTo'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EMAIL_BCC'
              ),
              align: 'start',
              sortable: false,
              value: 'emailBcc'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.SENDING_DAYS'
              ),
              align: 'start',
              sortable: false,
              value: 'monthlyReportSendingDays'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.IS_MONTHLY_REPORTING_ENABLED'
              ),
              align: 'start',
              sortable: false,
              value: 'isMonthlyReportingEnabled'
            },
            {
              text: '',
              align: 'end',
              sortable: false,
              value: 'actions'
            }
          ]"
          :items="parkingFineReportingTasks"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item.emailTo="props">
            <td>
              <div class="text-truncate" style="max-width: 248px">
                {{ props.item.emailTo }}
              </div>
            </td>
          </template>
          <template v-slot:item.emailBcc="props">
            <td>
              <div class="text-truncate" style="max-width: 248px">
                {{ props.item.emailBcc ? props.item.emailBcc : '-' }}
              </div>
            </td>
          </template>
          <template v-slot:item.isMonthlyReportingEnabled="props">
            <td>
              <v-icon
                small
                :color="
                  props.item.isMonthlyReportingEnabled ? 'success' : 'orange'
                "
              >
                {{
                  props.item.isMonthlyReportingEnabled
                    ? $vuetify.lang.t('$vuetify.YES')
                    : $vuetify.lang.t('$vuetify.NO')
                }}
              </v-icon>
            </td>
          </template>
          <template v-slot:item.actions="props">
            <td class="d-flex align-center justify-end">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    @click="openEditParkingFineReportingTaskDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    @click="onOpenLicensePlateListClick(props.item)"
                  >
                    <v-icon small color="blue">mdi-car</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.VEHICLE_LIST'
                    )
                  }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    @click="onParkingFineReportingTaskDelete(props.item)"
                    v-on="on"
                  >
                    <v-icon small color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.DELETE') }}
                </span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ParkingFineReportingTaskDialog
      v-if="parkingFineReportingTaskDialog"
      :visible="parkingFineReportingTaskDialog"
      @close="parkingFineReportingTaskDialog = false"
    />
    <VehicleGroupLicensePlatesDialog
      v-if="vehicleGroupLicensePlatesDialog"
      :visible="vehicleGroupLicensePlatesDialog"
      @close="vehicleGroupLicensePlatesDialog = false"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ParkingFineReportsTab',
  components: {
    ParkingFineReportingTaskDialog: () =>
      import(
        /* webpackChunkName: "ParkingFineReportingTaskDialog" */ '@/components/enforcement/ParkingFineReportingTaskDialog.vue'
      ),
    VehicleGroupLicensePlatesDialog: () =>
      import(
        /* webpackChunkName: "VehicleGroupLicensePlatesDialog" */ '@/components/enforcement/VehicleGroupLicensePlatesDialog.vue'
      )
  },
  data() {
    return {
      parkingFineReportingTaskDialog: false,
      vehicleGroupLicensePlatesDialog: false
    }
  },
  computed: {
    ...mapGetters('vehicleGroups', ['vehicleGroups']),
    ...mapGetters('enforcement', ['parkingFineReportingTasks'])
  },
  async mounted() {
    if (!this.parkingFineReportingTasks.length) {
      await this.getParkingFineReportingTasks()
    }
    if (!this.vehicleGroups.length) {
      await this.getAllVehicleGroups()
    }
  },
  methods: {
    ...mapActions('enforcement', [
      'getParkingFineReportingTasks',
      'deleteParkingFineReportingTask'
    ]),
    ...mapActions('vehicleGroups', ['getAllVehicleGroups']),
    ...mapMutations('enforcement', ['setSelectedParkingFineReportingTask']),
    openEditParkingFineReportingTaskDialog(item) {
      this.setSelectedParkingFineReportingTask(item)
      this.parkingFineReportingTaskDialog = true
    },
    onParkingFineReportingTaskDelete(item) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          this.deleteParkingFineReportingTask(item.ID)
        }
      })
    },
    onOpenLicensePlateListClick(item) {
      this.setSelectedParkingFineReportingTask(item)
      this.vehicleGroupLicensePlatesDialog = true
    }
  }
}
</script>
